import { RouteConfig } from 'vue-router';

import RouterView from '@/components/layout/Router.vue';
import { termsAddRoute } from './terms/add.route';
import { termsEditRoute } from './terms/edit.route';
import { termsRoute } from './terms/terms.route';

export const termsContainerRoute: RouteConfig = {
  path: 'terms',
  component: RouterView,
  children: [termsRoute, termsAddRoute, termsEditRoute],
  meta: {
    config: {
      title: 'menu.terms',
      name: 'termsList',
      icon: 'fal fa-clipboard-list',
      permissions: ['TERMS.LIST'],
      group: 'Ustawienia'
    },
    breadcrumb: {
      title: 'breadcrumbs.terms.list',
      name: 'termsList'
    }
  }
};
